import React, { useState, useEffect } from 'react';
import '../styles/SecurityLanding.css';

function SecurityLanding({ onStart }) {
  const [hoveredProduct, setHoveredProduct] = useState(null);

  // Set page title when landing page is shown
  useEffect(() => {
    document.title = 'TechHub Store - Shop Tech Products';
  }, []);

  const products = [
    { id: 1, name: 'Premium Wireless Headphones', price: '$129.99', rating: 4.8, reviews: 324 },
    { id: 2, name: 'Smart Watch Pro', price: '$199.99', rating: 4.9, reviews: 512 },
    { id: 3, name: '4K Webcam', price: '$89.99', rating: 4.7, reviews: 198 },
    { id: 4, name: 'USB-C Hub Pro', price: '$49.99', rating: 4.6, reviews: 267 },
    { id: 5, name: 'Portable SSD 1TB', price: '$129.99', rating: 4.9, reviews: 445 },
    { id: 6, name: 'Mechanical Keyboard RGB', price: '$159.99', rating: 4.8, reviews: 389 },
    { id: 7, name: 'Ergonomic Mouse Pro', price: '$79.99', rating: 4.7, reviews: 276 },
    { id: 8, name: 'Laptop Stand Aluminum', price: '$39.99', rating: 4.9, reviews: 521 },
  ];

  return (
    <div className="ecom-landing">
      {/* Navigation */}
      <nav className="ecom-navbar">
        <div className="nav-container">
          <div className="nav-brand">
            <span className="brand-name">TechHub Store</span>
          </div>
          <div className="nav-search">
            <input type="text" placeholder="Search products..." />
            <button>Search</button>
          </div>
          <div className="nav-actions">
            <button className="nav-btn">Wishlist</button>
            <button className="nav-btn" onClick={onStart}>Cart (0)</button>
            <button className="nav-btn">Account</button>
          </div>
        </div>
      </nav>

      {/* Hero Banner */}
      <section className="ecom-hero">
        <div className="hero-content">
          <h1>Premium Tech Products</h1>
          <p>Discover the latest gadgets and accessories at unbeatable prices</p>
          <button className="hero-cta" onClick={() => document.getElementById('computers-category').scrollIntoView({ behavior: 'smooth' })}>Shop Now</button>
        </div>
        <div className="hero-banner">
          <div className="banner-item">Mobile Devices</div>
          <div className="banner-item">Laptops</div>
          <div className="banner-item">Gaming</div>
          <div className="banner-item">Cameras</div>
        </div>
      </section>

      {/* Promo Banner */}
      <section className="promo-banner">
        <div className="promo-item">
          <div>
            <h3>Free Shipping</h3>
            <p>On orders over $50</p>
          </div>
        </div>
        <div className="promo-item">
          <div>
            <h3>100% Original</h3>
            <p>Authentic products guaranteed</p>
          </div>
        </div>
        <div className="promo-item">
          <div>
            <h3>Easy Returns</h3>
            <p>30-day money-back guarantee</p>
          </div>
        </div>
        <div className="promo-item">
          <div>
            <h3>Secure Payment</h3>
            <p>Multiple payment options</p>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="featured-section">
        <div className="section-header">
          <h2>Featured Products</h2>
          <p>Explore our best-selling items this week</p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <div
              key={product.id}
              className="product-card"
              onMouseEnter={() => setHoveredProduct(product.id)}
              onMouseLeave={() => setHoveredProduct(null)}
            >
              <div className="product-image">
                <span className="product-name">{product.name}</span>
                {hoveredProduct === product.id && (
                  <button className="quick-view">Quick View</button>
                )}
              </div>
              <div className="product-info">
                <h3>{product.name}</h3>
                <div className="product-rating">
                  <span className="stars">{product.rating} / 5</span>
                  <span className="reviews">({product.reviews} reviews)</span>
                </div>
                <div className="product-footer">
                  <span className="product-price">{product.price}</span>
                  <button className="add-to-cart">Add to Cart</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Categories */}
      <section className="categories-section">
        <h2>Shop by Category</h2>
        <div className="categories-grid">
          <div className="category-card category-1">
            <h3>Smartphones</h3>
            <p>2,450+ Products</p>
          </div>
          <div className="category-card category-2" id="computers-category">
            <h3>Computers</h3>
            <p>1,820+ Products</p>
          </div>
          <div className="category-card category-3">
            <h3>Audio</h3>
            <p>890+ Products</p>
          </div>
          <div className="category-card category-4">
            <h3>Cameras</h3>
            <p>650+ Products</p>
          </div>
          <div className="category-card category-5">
            <h3>Gaming</h3>
            <p>1,200+ Products</p>
          </div>
          <div className="category-card category-6">
            <h3>Wearables</h3>
            <p>540+ Products</p>
          </div>
        </div>
      </section>

      {/* Special Offer */}
      <section className="special-offer">
        <div className="offer-content">
          <div className="offer-text">
            <h2>Special Summer Sale!</h2>
            <p>Up to 50% off on selected items</p>
            <button className="offer-btn" onClick={() => document.getElementById('computers-category').scrollIntoView({ behavior: 'smooth' })}>Browse Deals</button>
          </div>
          <div className="offer-badge">
            <div className="discount-circle">
              <span className="discount">50%</span>
              <span className="discount-text">OFF</span>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <h2>What Our Customers Say</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <div className="testimonial-header">
              <div>
                <h4>John Smith</h4>
                <div className="rating">5 / 5 Stars</div>
              </div>
            </div>
            <p>"Excellent quality products and super fast shipping! Highly recommended."</p>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-header">
              <div>
                <h4>Sarah Johnson</h4>
                <div className="rating">5 / 5 Stars</div>
              </div>
            </div>
            <p>"Best prices I've found online. Customer service is fantastic!"</p>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-header">
              <div>
                <h4>Mike Chen</h4>
                <div className="rating">5 / 5 Stars</div>
              </div>
            </div>
            <p>"Love the easy returns policy. Great shopping experience overall."</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Start Shopping?</h2>
        <p>Browse thousands of quality products from trusted sellers</p>
        <button className="cta-btn" onClick={() => document.getElementById('computers-category').scrollIntoView({ behavior: 'smooth' })}>Continue Shopping</button>
      </section>

      {/* Newsletter */}
      <section className="newsletter-section">
        <h2>Subscribe to Our Newsletter</h2>
        <p>Get exclusive deals and updates delivered to your inbox</p>
        <div className="newsletter-form">
          <input type="email" placeholder="Enter your email" />
          <button>Subscribe</button>
        </div>
      </section>

      {/* Footer */}
      <footer className="ecom-footer">
        <div className="footer-content">
          <div className="footer-column">
            <h4>About TechHub</h4>
            <p>Your trusted online destination for premium tech products and gadgets.</p>
            <div className="social-links">
              <a href="#fb">Facebook</a>
              <a href="#tw">Twitter</a>
              <a href="#ig">Instagram</a>
            </div>
          </div>
          <div className="footer-column">
            <h4>Customer Service</h4>
            <ul>
              <li><a href="#help">Help Center</a></li>
              <li><a href="#track">Track Order</a></li>
              <li><a href="#returns">Returns</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Information</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#careers">Careers</a></li>
              <li><a href="#press">Press</a></li>
              <li><a href="#blog">Blog</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Policies</h4>
            <ul>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#terms">Terms of Service</a></li>
              <li><a href="#shipping">Shipping Info</a></li>
              <li><a href="#warranty">Warranty</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 TechHub Store. All rights reserved.</p>
          <div className="payment-methods">
            <span>Visa</span>
            <span>Mastercard</span>
            <span>American Express</span>
            <span>Bank Transfer</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SecurityLanding;
